import "core-js/modules/es.array.concat.js";
import React from 'react';
import { Icon } from '../Icon';
import { Product, Type } from './partials';
export var CompanyCard = function CompanyCard(_ref) {
  var type = _ref.type,
    name = _ref.name,
    image = _ref.image,
    link = _ref.link,
    web = _ref.web,
    withLink = _ref.withLink;
  var baseURL = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com');
  var url = link && link.href || "".concat(baseURL).concat(web || '');
  var linkProps = link && link.rel === 'external' ? {
    href: url,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {
    href: url
  };
  return React.createElement(Product, null, React.createElement(Icon, {
    url: withLink ? url : null,
    type: "company",
    size: 2,
    image: image ? "/image/".concat(image) : '',
    alt: name,
    margin: "0 15px 0 0",
    withBorder: true,
    verified: true
  }), React.createElement("div", null, type && React.createElement(Type, null, type), React.createElement("h4", null, withLink ? React.createElement("a", linkProps, name) : name)));
};